import Loadable from "react-loadable"
import Loading from "../../components/Loading"

export const BranchReport = Loadable({
  loader: () => import("./containers/BranchReport"),
  loading: Loading,
})

export const TransactionReport = Loadable({
  loader: () => import("./containers/TransactionReport"),
  loading: Loading,
})



// WEBPACK FOOTER //
// ./src/containers/SettlementReport/index.js